<template>
  <div class="date-picker-component">
    <div class="label" :style="{ width: labelWidth }">{{ labelValue }}</div>
    <div class="separator" />
    <div class="date-icon">
      <img src="~@/assets/images/calendar.svg" width="16" height="16" alt />
    </div>
    <div>
      <VueDatePicker format="YYYY-MM-DD" color="#4CC3E1" noHeader fullscreenMobile :minDate="minDate" v-model="dateValue" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.date-picker-component {
  display: flex;
  align-items: center;

  > div {
    &.label {
      font-size: 14px;
      font-style: normal;
      color: $brand-color-2;
      text-align: right;
    }

    &.separator {
      position: relative;
      margin: 0 10px;

      &::before {
        content: " ";
        position: absolute;
        top: -10px;
        left: 0;
        width: 1px;
        height: 20px;
        border-left: 1px solid $brand-color-2;
      }
    }

    &.date-icon {
      img {
        vertical-align: top;
      }
    }
  }

  /deep/ .datepicker-weekday {
    font-size: 13px;
    font-weight: 600;
  }
}
</style>

<script>
import { VueDatePicker } from "@mathieustan/vue-datepicker";

export default {
  name: "DatePicker",
  components: {
    VueDatePicker,
  },
  props: {
    label: {
      type: String,
    },
    labelWidth: {
      type: String,
      default: "auto",
    },
    minDate: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      dateValue: this.value,
    };
  },
  computed: {
    labelValue() {
      return this.label ? this.label : "DATE";
    },
  },
  watch: {
    value() {
      this.dateValue = this.value;
    },
    dateValue() {
      this.$emit("input", this.dateValue);
    },
  },
};
</script>
